import apiClient from "../common/apiClient";

export default class SubDepartmentController {
  async Create(data, token) {
    try {
      return await apiClient.post("/sub-department", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(departmentId, data, token) {
    try {
      return await apiClient.put("/sub-department/" + departmentId, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/sub-department/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetSubDepartmentById(id, token) {
    try {
      return await apiClient.get("/getSubDepartment/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async GetAllSubDepartment(token) {
    try {
      return await apiClient.get("/getAllSubDepartment", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
